import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Solicitacao } from '../../model/solicitacao';
import { environment } from '../../../../environments/environment';
import { Emissao } from '../../model/emissao';
import { catchError } from 'rxjs/operators';
import { AutenticacaoCustom } from '../../model/autenticacaoCustom';

@Injectable()
export class SolicitacoesService {

    constructor(private http: HttpClient) { }

    listar(organizacaoId: number): Observable<Solicitacao[]> {
        return this.http.get<Solicitacao[]>(environment.backendBaseUrl + '/manager/solicitacoes/organizacao/' + organizacaoId).pipe(
            catchError(this.handleErrorObservable));
    }

    buscarTermo(numeroPedido: string): Observable<Emissao> {
        return this.http.get<Emissao>(environment.backendBaseUrl + '/manager/solicitacoes/buscarTermo/' + numeroPedido).pipe(
            catchError(this.handleErrorObservable));
    }

    aprovar(solicitacao: Solicitacao): Observable<Solicitacao> {
        return this.http.post<Solicitacao>(environment.backendBaseUrl + `/manager/solicitacoes/aprovarimportar`, solicitacao).pipe(
            catchError(this.handleErrorObservable));
    }

    rejeitar(solicitacao: Solicitacao, organizacaoId: number): Observable<Solicitacao> {
        return this.http.post<Solicitacao>(environment.backendBaseUrl + `/manager/solicitacoes/organizacao/${organizacaoId}/rejeitar`, solicitacao).pipe(
            catchError(this.handleErrorObservable));
    }

    private handleErrorObservable(error: HttpErrorResponse | any) {
        console.error(error.error.message);
        return observableThrowError(error.error || error);
    }

    consultarPedido(numeroPedido: string, codigoAutenticacao: string): Observable<any> {
        AutenticacaoCustom.setAutenticacaoCustom(`${codigoAutenticacao}`);

        return this.http.get<Emissao>(environment.backendBaseUrl + '/manager/solicitacoes/consultarPedido/' + numeroPedido).pipe(
            catchError(this.handleErrorObservable));
    }

    finalizarEmissao(emissao: Emissao): Observable<any> {
        return this.http.post(environment.backendBaseUrl + '/manager/solicitacoes/finalizarEmissao', emissao).pipe(
            catchError(this.handleErrorObservable));
    }
}